export default __webpack_public_path__ + "static/media/maduroBg.170af92c.jpg";